import { parseSetCookie } from "cookie";
import { createRouter, eventHandler, readBody, defineNodeMiddleware, createEvent } from "h3";
import * as z from "zod";
import { decode } from "../lib/decode.js";
const PrismicAuthResponseSchema = z.object({
  email: z.string(),
  cookies: z.array(z.string())
});
const createPrismicAuthManagerMiddleware = (args) => {
  const router = createRouter();
  router.post("/", eventHandler(async (event) => {
    const body = await readBody(event);
    const { value, error } = decode(PrismicAuthResponseSchema, body);
    if (error) {
      throw new Error(`Invalid auth payload: ${error.errors.join(", ")}`);
    }
    const token = value.cookies.map((c) => parseSetCookie(c)).find((c) => c.name === "prismic-auth")?.value;
    if (!token) {
      throw new Error("No token found in cookies");
    }
    await args.prismicAuthManager.login({
      email: value.email,
      token
    });
    if (args.onLoginCallback) {
      await args.onLoginCallback();
    }
    return {};
  }));
  return defineNodeMiddleware(async (req, res) => {
    const event = createEvent(req, res);
    await router.handler(event);
    res.end();
  });
};
export {
  createPrismicAuthManagerMiddleware
};
//# sourceMappingURL=createPrismicAuthManagerMiddleware.js.map
